<div class="date">
  <div class="day-text">{{ data.date | date: 'EEEE' }}</div>
  <div class="day">{{ data.date | date: 'd' }}</div>
  <div class="month">{{ data.date | date: 'MMMM' }}</div>
</div>

<div class="separator color-separator"></div>

<div class="main-content">
  <ng-container *ngIf="!academicEvent">
    <div class="mane mane-format">
      <span class="format-click-text" (click)="openEventPopup()">{{ data.courseName }}</span>
      <app-event-details 
        *ngIf="currentEvent" 
        [event]="currentEvent" 
        [color]="getPopupColor()"
        (close)="closeEventPopup()" 
        [notificationsHeaderText]="notificationsHeaderText"
      />
    </div>

    <div class="separator"></div>
  </ng-container>

  <div class="details">
    <div *ngIf="!academicEvent" class="details-description">{{ data.name }}</div>
    <div *ngIf="academicEvent" class="details-description mane details-description-format">
      <span class="format-click-text" (click)="openEventPopup()">{{ data.name }}</span>
      <app-event-details 
        *ngIf="currentEvent" 
        [event]="currentEvent" 
        [color]="getPopupColor()"
        (close)="closeEventPopup()" 
        [notificationsHeaderText]="notificationsHeaderText" 
      />
    </div>
    <div class="details-row">
      <ng-container *ngIf="!data.assignmentSubmissionDate">
        <div *ngIf="!isTimeEmpty(data.date)" class="details-item">
          <mat-icon [svgIcon]="'clock'" class="square-icon details-item-icon"></mat-icon>
          בשעה {{ data.date.replace('Z', '')| date: 'HH:mm' }}
        </div>

        <div *ngIf="data.location" class="details-item">
          <mat-icon [svgIcon]="'location'" class="square-icon details-item-icon"></mat-icon>
          {{ data.location }}
        </div>

        <div *ngIf="data.description" class="details-item">
          <mat-icon [svgIcon]="'info-2'" class="square-icon details-item-icon"></mat-icon>
          {{ data.description }}
        </div>
      </ng-container>
      
      <div *ngIf="data.bubbleText" class="details-item badge primary-orange">{{data.bubbleText}}</div>
    </div>
  </div>
</div>

<div *ngIf="data.notifications && data.notifications.length" class="notifications">
  <a class="notification-link" (click)="openNotificationFromMain($event)">
    <mat-icon [svgIcon]="'bell-point'" class="notification-icon"></mat-icon>
    <span class="notification-text">{{ data.notifications.length }} {{ notificationsHeaderText }}</span>
  </a>
</div>

<app-lesson-notifications *ngIf="openedMainNotifications" [notifications]="data.notifications" [headerText]="notificationsHeaderText" (close)="closeMainNotifications()" />